import { Http } from '../library';
import { httpMethods } from '../enums';
import * as Endpoints from '../constants/endpoints.constant';
import api from '../api/client';

/* eslint-disable */
class PassbookService {
  /**
   * Get wallet transactions
   * @param customerId
   * @param page
   * @param query
   */
  async getWalletTransactions(
    customerId: number,
    page: number,
    userId: any,
    query: string = null
  ) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(
        `${
          Endpoints.WALLET_TRANSACTION
        }?customerId=${customerId}&user_id=${userId}&page=${page}&pageSize=10${
          query ? query : ''
        }`
      )
      .setToken(api.getToken())
      .request();
  }

  /**
   * Get metal transactions
   * @param customerId
   * @param page
   * @param accountId
   * @param query
   */
  async getMetalTransactions(
    customerId: number,
    page: number,
    accountId: string,
    userId: any,
    query: string,
    partnerId:any
  ) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(
        `${Endpoints.ORDER}?customerId=${customerId}&user_id=${userId}&accountId=${accountId}&page=${page}&pageSize=8&partnerId=${partnerId}&order=desc${query}`
      )
      .setToken(api.getToken())
      .request();
  }

  /**
   * Get Invoices
   */
  async getBarInvoices() {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.GET_INVOICES}`)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Get Specific Invoice Details of Bar Allocation
   * @param invoiceNumber
   */
  async getBarAllocationInvoice(invoiceNumber: string) {
    const data = {
      invoiceNo: invoiceNumber,
    };
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(`${Endpoints.BAR_ALLOCATION_REPORT}`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Get price rules
   * @param metalCode
   */
  async getPriceRules(metalCode: any,partnerId) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(
        `${Endpoints.PRICE_RULES}?metalCode=${metalCode}&partnerId=${partnerId}&currency=INR&uom=g&type=QTY&value=1`
      )
      .setToken(api.getToken())
      .request();
  }

  /**
   * Get order details
   * @param orderRef
   */
  async getOrderDetails(orderRef: any, userId: any) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.ORDER}?orderRef=${orderRef}&user_id=${userId}`)
      .setResponseType('json')
      .setToken(api.getToken())
      .request();
  }
}

export default new PassbookService();
